import * as React from 'react';
import { createSvgIcon } from '@mui/material';
createSvgIcon( /*#__PURE__*/React.createElement("svg", {
  width: "16px",
  height: "12px",
  viewBox: "0 0 16 12",
  version: "1.1"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M5.825,9.16666667 L2.5,12.5 L5.825,15.8333333 L5.825,13.3333333 L11.6666667,13.3333333 L11.6666667,11.6666667 L5.825,11.6666667 L5.825,9.16666667 L5.825,9.16666667 Z M17.5,7.5 L14.175,4.16666667 L14.175,6.66666667 L8.33333333,6.66666667 L8.33333333,8.33333333 L14.175,8.33333333 L14.175,10.8333333 L17.5,7.5 L17.5,7.5 Z",
  id: "map-path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "map-Map-Data",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "map-Map-Data-on-focus_no-mapping",
  transform: "translate(-1295.000000, -594.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "map-Group-13",
  transform: "translate(582.000000, 362.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "map-Group-4"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_swap_horiz",
  transform: "translate(711.000000, 228.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "map-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  href: "#map-path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask"
}), /*#__PURE__*/React.createElement("g", {
  id: "Colors/Dark-Gray",
  mask: "url(#map-mask-2)",
  fill: "#616161",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-10.833333, -10.833333)",
  id: "map-Rectangle-Copy-29"
}, /*#__PURE__*/React.createElement("rect", {
  x: "0",
  y: "0",
  width: "41.6666667",
  height: "41.6666667"
}))))))))), 'Map');